/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Franchise_UsersInputs */

const cs_franchise_users = /** @type {(inputs: Franchise_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uživatelé`)
};

const en_franchise_users = /** @type {(inputs: Franchise_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Users`)
};

/**
* | output |
* | --- |
* | "Users" |
*
* @param {Franchise_UsersInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const franchise_users = /** @type {((inputs?: Franchise_UsersInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Franchise_UsersInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_franchise_users(inputs)
	return cs_franchise_users(inputs)
});